import { xcss } from '@atlaskit/primitives';
import styled from '@emotion/styled';

export const deleteContacts = xcss({
  ':hover': {
    backgroundColor: 'color.background.neutral.hovered',
  },
});

export const DeleteButton = styled.div`
  cursor: pointer;
  border-radius: 3px;
`;
